import { render } from "./form-actions.vue?vue&type=template&id=68b072c2&lang=pug"
import script from "./form-actions.vue?vue&type=script&setup=true&lang=js"
export * from "./form-actions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__